// Dropdown options are { id, name }. Checked by the id key, not its truthiness: a Yes/No option
// has id false, and sending the whole object would make the backend read it as true.
const isOption = value =>
  value !== null && typeof value === 'object' && 'id' in value;

const setArrayValues = item => {
  return isOption(item.values[0])
    ? item.values.map(val => val.id)
    : item.values;
};

// Attributes whose UI input is a single free-text box but whose API payload is a
// list: the user types "a, b, c" and each entry becomes its own value. Exported so
// the reverse direction (customViewsHelper) joins them back with the same rule.
export const COMMA_SEPARATED_ATTRIBUTES = [
  'content',
  'email',
  'attachment_extension',
  'display_id',
];

// The value may arrive as the raw string the user typed, or as an already-split
// array when the filter comes back from the store (an applied filter re-opened in
// the modal, or one built from the URL), so handle both.
export const splitCommaSeparatedValues = values =>
  (Array.isArray(values) ? values : [values ?? ''])
    .map(value => value?.id ?? value)
    .flatMap(value => String(value).split(','))
    .map(value => value.trim())
    .filter(value => value.length > 0);

const generateValues = item => {
  if (COMMA_SEPARATED_ATTRIBUTES.includes(item.attribute_key)) {
    return splitCommaSeparatedValues(item.values);
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    item.values = generateValues(item);
    return item;
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
